import React from 'react'
import { Checkbox } from 'semantic-ui-react'

//@ts-ignore
import withLookups from 'shared/containers/withLookups'
import { LocalLoader } from 'shared'
//@ts-ignore
import FormElement from 'shared/newFormElements'

import translate from '../../translator'

import { EntriesCheckboxProps } from '../../types.LoanDetails'

@withLookups({
  type: 'loanview',
  query: ['AccOper as operationTypes', 'EntryOperType as entryOperationTypes'],
})
class CheckboxFilters extends React.Component<EntriesCheckboxProps> {
  static defaultProps = {
    operationTypes: [],
    entryOperationTypes: [],
  }

  state = {
    allTypesVisible: false,
    otherOperationsVisibile: false,
    allTypesCheckboxVisible: true,
    otherOperationsCheckboxVisible: true,
  }

  render() {
    const { operationTypes, entryOperationTypes } = this.props
    return (
      <>
        <div className="u-flex u-alignCenter">
          <Checkbox
            style={{ width: 250 }}
            label={translate('chk_entries_credit')}
            checked={this.state.allTypesCheckboxVisible}
            onChange={(_, { checked }) => {
              if (checked) this.setState({ allTypesCheckboxVisible: true })
              else {
                this.setState({ allTypesCheckboxVisible: false })
                this.setState({ allTypesVisible: false })
              }
            }}
          />

          {this.state.allTypesCheckboxVisible && (
            <Checkbox
              style={{ width: 150 }}
              label={translate('chk_all_accoper')}
              checked={!this.state.allTypesVisible}
              onChange={(_, { checked }) => {
                if (checked) this.setState({ allTypesVisible: false })
                else this.setState({ allTypesVisible: true })
              }}
            />
          )}

          <div style={{ width: 270 }}>
            {this.state.allTypesVisible && (
              <LocalLoader loading={!operationTypes.length}>
                {!!operationTypes.length && (
                  <FormElement
                    type="select"
                    name="AccOperID"
                    defaultValue={operationTypes[0].ID}
                    options={operationTypes}
                    search
                    fluid
                  />
                )}
              </LocalLoader>
            )}
          </div>
        </div>
        <div className="u-flex u-alignCenter">
          <Checkbox
            style={{ width: 200 }}
            label={translate('chk_entries_external')}
            checked={this.state.otherOperationsCheckboxVisible}
            onChange={(_, { checked }) => {
              if (checked) this.setState({ otherOperationsCheckboxVisible: true })
              else {
                this.setState({ otherOperationsCheckboxVisible: false })
                this.setState({ otherOperationsVisibile: false })
              }
            }}
          />

          {this.state.otherOperationsCheckboxVisible && (
            <Checkbox
              style={{ width: 200 }}
              label={translate('chk_all_entrytype')}
              defaultChecked
              onChange={(_, { checked }) => {
                if (checked) this.setState({ otherOperationsVisibile: false })
                else this.setState({ otherOperationsVisibile: true })
              }}
            />
          )}

          <div style={{ width: 270 }}>
            {this.state.otherOperationsVisibile && (
              <LocalLoader loading={!entryOperationTypes.length}>
                {!!entryOperationTypes.length && (
                  <FormElement
                    type="select"
                    name="AccEntryTypeID"
                    defaultValue={entryOperationTypes[0].ID}
                    options={entryOperationTypes}
                    search
                  />
                )}
              </LocalLoader>
            )}
          </div>
        </div>
      </>
    )
  }
}

export default CheckboxFilters
